import type { FaireProductEntity } from "../../entity_types/product";

export const p_gpb23epjqu: FaireProductEntity = {
  token: "p_gpb23epjqu",
  type: "product",
  name: "Waist-Cinching Floor Maxi Dress",
  brandToken: "b_f4kavkbe9g",
  brandName: "HIDDENBRAND",
  imageUrl:
    "https://cdn.faire.com/fastly/96a009b085507571ded0825c34f712053625ec49fdf9c4cfb34bba1274d7417b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/55dd681b3910f45cc3f55a94ce951cc6bac402453b8e286503c069f78999d9a0.jpeg",
    "https://cdn.faire.com/fastly/93fa7911ee5665c480720bc70cd5a6e7ef90055a0caebc7c80145a1e3e33c664.jpeg",
    "https://cdn.faire.com/fastly/b72bd4786ffd10f8f58e80adcaf8bc499943a2f1c9be086cddc12c8c4803c18c.jpeg",
    "https://cdn.faire.com/fastly/839024dd1d173366d44da79544cb3bf2f87fe7dc10cb12118640654b07f47f5b.jpeg",
    "https://cdn.faire.com/fastly/14337f5c44cb0b3615f4b7e5d6ef8993d864db5f02cbb5cf3eecbefaf35b0551.jpeg",
    "https://cdn.faire.com/fastly/3dec0ffd0ff7ea813ae0d11f9ea10f5fd79a775b9493ef06500cb1ecce205a05.jpeg",
    "https://cdn.faire.com/fastly/6176e36fdeda0403bbd73cf4e88d649e3aff94676c70b7347d1fd1e08fcf359c.jpeg",
    "https://cdn.faire.com/fastly/de22b5fa5d945a8fba24a2ca1afdcbcec0c1ed2c4e94672e9ee8aa4a04837a5e.jpeg",
    "https://cdn.faire.com/fastly/4fde9b071e2ec552ed8a70826ee388d7464beafab44dba0aff6582166c143c8a.jpeg",
    "https://cdn.faire.com/fastly/c74769723e41a75f2d7d34098f4708451eee7e22f79616c2183ac45ddf5e1dc1.jpeg",
    "https://cdn.faire.com/fastly/566407bd85d6b8069b0df03d00bf2dd22ed2d4fa117ef0ffc87f62ba0f1f6197.jpeg",
    "https://cdn.faire.com/fastly/036fa8727142dd2c3945ef67a16651cdca2c83030cd1314ac98310cf0213c67f.jpeg",
    "https://cdn.faire.com/fastly/878170a763ed369bedee0d87b9e0efb39aa0ae3a3bfa6f9c1b8ff9d22d16bdaa.jpeg",
    "https://cdn.faire.com/fastly/6b13f52084b0eb0e8e248cb5b81b1de1dcc21c0308a22acd47385bbf05dafd45.jpeg",
  ],
  priceDollars: 15.94,
  description:
    "Import duties are paid by the HiddenBrand_HJW02384\nOur product size standards are different, please check the size information before placing an order.\n\nSize Chart (Inch)\nChest\tLength\tWaist\tHip\nS\t32.30\t59.10\t25.20\t18.90\nM\t33.90\t59.40\t26.80\t19.10\nL\t35.40\t59.80\t28.30\t19.30\nXL\t37.00\t60.20\t29.90\t19.50\n2XL\t38.60\t60.60\t31.50\t19.70\n\nWomen blazer, shackets, crochet cardigan, cable knit sweater, ruffle dress, eyelet blouse, puff sleeve top, floral dress, denim skirts, denim shorts, ripped jeans, Women jeans, maxi skirt, floral dress, jumpsuit, crop top, short sleeve, wholesale t shirts, beach cover ups, women t shirt, women shorts, women pants, bohemian, boho, fall top, fall t shirt, fall dress, maxi dress, fall tee, women fall top, fall blouse, western",
  tags: [],
  msrpDollars: 31.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:10.436Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
